/**
 * @file ComposerStrip.tsx
 * @description Полосы над полем ввода и вместо него (chat-window-design.md
 * §4, §5): «Диалог ведёт Анна Кравец…» [Взять себе], «У диалога нет
 * ответственного.» [Взять себе], «Диалог в архиве…» [Вернуть из архива],
 * «только чтение» при входе под сотрудником, «Диалог больше не назначен вам»
 * [К списку]. Какая полоса — решает `composerStripKind` (реестр, не
 * каскад в разметке).
 */

import { Button } from "../ui/button";
import { NoticeStrip } from "../ui/NoticeStrip";
import type { ConversationDetail } from "../../lib/api-chat";
import { CHAT_TEXT } from "./chat-texts";
import type { ComposerStripKind } from "./composer-strip-kind";

interface Props {
  kind: Exclude<ComposerStripKind, null>;
  detail: ConversationDetail | null;
  busy: boolean;
  onTake: () => void;
  onUnarchive: () => void;
  onToList: () => void;
}

const ACTION_CLASS = "min-h-12 shrink-0 lg:min-h-9";

export function ComposerStrip({ kind, detail, busy, onTake, onUnarchive, onToList }: Props) {
  switch (kind) {
    case "readOnly":
      return <NoticeStrip tone="info">{CHAT_TEXT.stripReadOnly}</NoticeStrip>;
    case "lost":
      return (
        <NoticeStrip tone="warning" action={<Button variant="outline" className={ACTION_CLASS} onClick={onToList}>{CHAT_TEXT.toList}</Button>}>
          {CHAT_TEXT.stripLost}
        </NoticeStrip>
      );
    case "archived":
      return (
        <NoticeStrip
          tone="info"
          action={
            detail?.actions.unarchive ? (
              <Button variant="soft" className={ACTION_CLASS} loading={busy} onClick={onUnarchive}>
                {CHAT_TEXT.unarchive}
              </Button>
            ) : undefined
          }
        >
          {CHAT_TEXT.stripArchived}
        </NoticeStrip>
      );
    case "foreign":
    case "unassigned": {
      const text = kind === "foreign" ? CHAT_TEXT.stripForeign(detail?.assignedUser?.name ?? "") : CHAT_TEXT.stripUnassigned;
      return (
        <NoticeStrip
          tone="warning"
          action={
            detail?.actions.take ? (
              <Button variant="soft" className={ACTION_CLASS} loading={busy} onClick={onTake}>
                {CHAT_TEXT.take}
              </Button>
            ) : undefined
          }
        >
          {text}
        </NoticeStrip>
      );
    }
  }
}
